import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Copy01 = function Copy01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5 15c-.9319 0-1.3978 0-1.7654-.1522a2 2 0 0 1-1.0824-1.0824C2 13.3978 2 12.9319 2 12V5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 2 4.08 2 5.2 2H12c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C15 3.6022 15 4.0681 15 5m-2.8 17h6.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-6.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 9 19.9201 9 18.8 9h-6.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C9 10.5198 9 11.0799 9 12.2v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218"
    })
  }));
};
export default Copy01;